const _temp0 = require("./config/25madison.json");
const _temp1 = require("./config/demo.json");
const _temp2 = require("./config/dev.json");
const _temp3 = require("./config/harvest.json");
const _temp4 = require("./config/odyssey.json");
const _temp5 = require("./config/testing.json");
module.exports = {
  "25madison": _temp0,
  "demo": _temp1,
  "dev": _temp2,
  "harvest": _temp3,
  "odyssey": _temp4,
  "testing": _temp5
}